import PreSubmitFormController from '@/controllers/pre_submit_form_controller'
import { DateTime } from 'luxon'

export default class extends PreSubmitFormController {
  static targets = ['container', 'element']

  static values = {
    ...super.values,
    endTime: String,
    orderId: Number,
  }

  connect() {
    this.setCountDownTimer()

    // TODO: Fix this
    // subscribe to channel
    // this.channel = CampusESP.cable.subscriptions.create({ channel: 'ExpireCartChannel', order_id: this.orderIdValue }, {
    //   connected: this._cableConnected.bind(this),
    //   disconnected: this._cableDisconnected.bind(this),
    //   received: this._cableReceived.bind(this),
    // });
  }

  // Called whenever you use this.formData
  get formData() {
    return {}
  }

  // this will handle checking and displaying a countdown timer of when a users
  // order is going to expire. The container will hidden until there are only
  // 5 minutes left to complete the order
  setCountDownTimer() {
    const timer = setInterval(() => {
      const endTime = DateTime.fromISO(this.endTimeValue)
      const duration = endTime.diffNow(['minutes', 'seconds'])

      // if there is no time remaining, submit the request to release the inventory
      if (duration.seconds < 0) {
        this.preSubmit()
        clearInterval(timer)
      } else if (duration.minutes < 5) {
        this.containerTarget.classList.remove('hidden')
        this.elementTarget.innerHTML = duration.toFormat('m:ss')
      }
    }, 1000)
  }

  // TODO: This will be implemetned when using action cable
  // 1. perfrom broadcast_expiration_status to check if the order has expired or is close to expiring
  // 2. update the countdown timer using luxon.
  // setOrderInterval() {
  //   this.timer = setInterval(() => {
  //     this.channel.perform("broadcast_expiration_status")
  //
  //     // if container is not hidden, display countdown
  //     if (this.containerTarget.classList.contains('hidden') === false) {
  //       const endTime = DateTime.fromISO(this.endTimeValue)
  //       const duration = endTime.diffNow(['minutes', 'seconds'])
  //
  //       if (duration.seconds < 0) {
  //         return
  //       }
  //
  //
  //       this.elementTarget.innerHTML = duration.toFormat('m:ss')
  //     }
  //   }, 1000)
  // }

  preSubmit(event, ...callbacks) {
    const submitFn = async () => {
      super.preSubmit(
        event,
        async (response) => {
          const data = await response.json()

          window.location.href = data.redirect_url
        },
        ...callbacks,
      )
    }
    submitFn()
  }

  // after cable has connected, set the order interval to check if the order has expired or is near expiring
  _cableConnected() {
    this.setOrderInterval()
  }

  // after channel has been disconnected, make sure to clear the interval
  _cableDisconnected() {
    clearInterval(this.timer)
  }

  // capture the data passed back through the channel from the server
  _cableReceived(data) {
    // 1. if the order reservation has expired, submit the form to release the inventory and send the user back
    // to the edit order view
    // 2. if the order is expiring soon (Within 5 minutes), display the hidden div
    if (data.expired === true) {
      this.preSubmit()
    } else if (data.expiresSoon === true) {
      this.containerTarget.classList.remove('hidden')
    }
  }
}
